"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stage = void 0;
var Stage;
(function (Stage) {
    Stage["Test"] = "test";
    Stage["Local"] = "local";
    Stage["Beta"] = "beta";
    Stage["Gamma"] = "gamma";
    Stage["Prod"] = "prod";
})(Stage = exports.Stage || (exports.Stage = {}));
